const CheckIcon = ({ className }: { className?: string }) => {
  return (
    <svg viewBox="0 0 10 10" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path fillRule="evenodd" clipRule="evenodd" d="M9.22494 1.67119C9.03255 1.49796 8.73617 1.51349 8.56294 1.70588L3.31035 7.53947L1.44406 5.46675C1.27083 5.27436 0.97444 5.25883 0.782052 5.43205C0.589664 5.60528 0.574131 5.90167 0.747358 6.09406L2.95557 8.54653C3.08001 8.68473 3.268 8.73167 3.43534 8.68294C3.52259 8.66105 3.6045 8.61386 3.66921 8.54199L9.25964 2.33319C9.43286 2.1408 9.41733 1.84441 9.22494 1.67119Z" fill="currentColor"/>
    </svg>

  )
}

export default CheckIcon